
import { ITrackingPoint, IWarehouse } from '@/apis/masterDataAPI'
import SearchItemField from '@/components/barcodeSearch/SearchItemField.vue'
import { ISupplier } from '@/utils/types/model/supplier'
import { IWorkcenter } from '@/utils/types/model/workcenter'
import cloneDeep from 'lodash/cloneDeep'
import { Options } from 'vue-class-component'
import { Mixins, Prop } from 'vue-property-decorator'

@Options({ components: {}, name: 'SearchItemMarumiya' })
export default class SearchItemMarumiya extends Mixins(SearchItemField) {
  @Prop({ type: Object }) masterData!: Record<string, IWorkcenter | ISupplier | ITrackingPoint | IWarehouse>

  created() {
    this.oldData = cloneDeep(this._searchItem)
  }
}
